// extracted by mini-css-extract-plugin
module.exports = {"response":"Documents-m__response___Qaba0","option":"Documents-m__option___1Lll7","icon":"Documents-m__icon___2893x","hidden":"Documents-m__hidden___3f4YQ"};